// extracted by mini-css-extract-plugin
export default {"products":"Gu-z","card":"Hu-z","oosMessaging":"Iu-z"};